angular.module('NiacsProjectApp.lms', [
    'templates-niacs',
    'NiacsProjectApp.controllers-general',
    'NiacsProjectApp.directives', // panels, etc.
    'NiacsProjectApp.lms-services',
    'NiacsProjectApp.lms-filters',
    'NiacsProjectApp.lms-directives',
    'ui.bootstrap',
    'ui.bootstrap.alert',
    'monospaced.elastic',
    'ngAnimate'
  ]
);